import { jsxs as z, jsx as a } from "react/jsx-runtime";
import * as F from "@radix-ui/react-popover";
import te, { useRef as R, useState as x, useEffect as re, useCallback as c, isValidElement as ae, cloneElement as oe, useLayoutEffect as fe, useMemo as se } from "react";
import j from "./index.es662.js";
import { noop as K } from "lodash/fp";
import { PopoverContainer as me } from "./index.es82.js";
import { useEventOnScroll as ue } from "@placer-ui/hooks";
import { SlimSearch as ce } from "./index.es155.js";
import { useScreenZoom as pe } from "./index.es589.js";
import { MultiSelectDropdownMenu as de } from "./index.es77.js";
import { FilterIcon as ne } from "./index.es290.js";
import { onKeyDownEnterAndSpace as ve } from "./index.es526.js";
import { DrawerTemplate as Te } from "./index.es122.js";
const _e = "dropdown-component", ie = ({
  open: C,
  trigger: y,
  children: b,
  appendToParent: g,
  parentElement: w,
  menuWidth: L,
  minWidth: P,
  disabled: p,
  isLocked: O,
  testId: s = _e,
  defaultOpen: I = !1,
  disableAutoClosing: Z = !1,
  closeOnSelection: k = !1,
  triggerWrapper: U = "none",
  onInlineSearch: r,
  setOpen: n = K,
  onOutsideClick: v = K,
  onOpenChange: T = K,
  triggerMerge: A = !0,
  inlineEditFiltersMenu: t,
  hideWhenDetached: q = !0,
  isInlineModeVisible: _,
  closeDropdownWhenScrolling: o,
  ...N
}) => {
  const i = R(null), B = R(null), [G, E] = x(""), [H, S] = x(!1), d = pe().zoomPercentage >= 250, [m, $] = x(C ?? !1), [J, M] = x((t == null ? void 0 : t.items) || []);
  re(() => {
    $(C ?? !1);
  }, [C]);
  const f = c(
    (e) => {
      $(e), n == null || n(e), T == null || T(e), r == null || r("");
    },
    [r, T, n]
  ), Q = c(() => {
    !O && !p && f(!m);
  }, [O, p, m, f]), X = c(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      setTimeout(() => {
        v == null || v();
      }, 100), Z && e.preventDefault();
    },
    [Z, v]
  ), l = c(
    (e) => {
      setTimeout(() => {
        k && !_ && f(!1);
      }, 1);
    },
    [k, _, f]
  ), {
    scaleToAnchor: Re,
    alignOffset: xe,
    zIndex: Ce,
    inlineMode: ye,
    hasCustomItem: be,
    ...W
  } = N;
  let u = ae(y) ? oe(y, {
    role: "button",
    "aria-haspopup": "true",
    "aria-expanded": m,
    ...p ? { "aria-disabled": "true" } : {},
    ...W
  }) : y;
  U === "block" ? (console.warn("The `block` trigger wrapper is deprecated. Please use  `none` instead."), u = /* @__PURE__ */ a("div", { className: j.triggerContainer, children: u })) : U === "inline" && (console.warn("The `block` trigger wrapper is deprecated. Please use  `none` instead."), u = /* @__PURE__ */ a("span", { className: j.triggerContainer, children: u }));
  const Y = c(
    (e) => {
      E(e), r == null || r(e);
    },
    [r]
  );
  fe(() => {
    setTimeout(() => {
      var e;
      r && m && ((e = B.current) == null || e.focus());
    }, 20);
  }, [m, r]);
  const D = R(null), V = R(null);
  ue(() => $(!1), {
    enabled: !!o,
    excludeRefs: [
      D,
      V,
      ...(o == null ? void 0 : o.excludeRefs) || []
    ],
    debounceMs: (o == null ? void 0 : o.debounceMs) || 1e3,
    useCapture: (o == null ? void 0 : o.useCapture) || !0
  });
  const h = se(
    () => /* @__PURE__ */ z(
      me,
      {
        "data-testid": `${s}-popover-container`,
        onPointerDownOutside: X,
        parentElement: g ? w || i.current : void 0,
        hideWhenDetached: q,
        isInlineModeVisible: _,
        setOpenState: f,
        isRawContent: d,
        ref: V,
        minWidth: P,
        ...N,
        children: [
          r && /* @__PURE__ */ a(
            ce,
            {
              onChange: Y,
              placeholder: "Search",
              rightLeftPadding: "12px",
              value: G,
              disableLoading: !0,
              ref: B,
              CTA: t ? /* @__PURE__ */ a(
                ie,
                {
                  testId: `${s}-inline-filters-menu`,
                  trigger: t.triggerIcon || /* @__PURE__ */ a("button", { "aria-label": "Filter options", children: /* @__PURE__ */ a(ne, { color: "gray" }) }),
                  side: t.side,
                  align: t.align,
                  onOpenChange: S,
                  sideOffset: t.sideOffset,
                  alignOffset: t.alignOffset,
                  menuWidth: t.menuWidth || 200,
                  children: /* @__PURE__ */ a(
                    de,
                    {
                      items: J,
                      onSelection: (e) => {
                        M(e), t.onSelection(e);
                      },
                      onItemSelection: t.onItemSelection
                    }
                  )
                }
              ) : void 0
            }
          ),
          /* @__PURE__ */ a(
            "div",
            {
              onClick: l,
              onKeyDown: (e) => ve(e, l, !1),
              style: {
                minWidth: P,
                width: d ? "100%" : L || "unset"
              },
              role: "presentation",
              children: d ? te.cloneElement(b, { autoFocus: !0 }) : b
            }
          )
        ]
      }
    ),
    [
      Y,
      g,
      b,
      q,
      t,
      J,
      G,
      _,
      d,
      L,
      P,
      r,
      l,
      X,
      w,
      N,
      f,
      s
    ]
  ), ee = c(
    (e) => {
      H || f(e);
    },
    [H, f]
  );
  return d ? /* @__PURE__ */ z("div", { ref: i, "data-testid": s, children: [
    /* @__PURE__ */ a("button", { onClick: Q, className: j.drawerTriggerContainer, children: u }),
    /* @__PURE__ */ a(
      Te,
      {
        isOpen: m,
        container: g ? w || i.current : void 0,
        setIsOpen: ee,
        header: { title: "Select an Option", actionType: "close-help" },
        testId: `${s}-drawer-version`,
        width: "100%",
        children: h
      }
    )
  ] }) : /* @__PURE__ */ a("div", { ref: i, "data-testid": s, "data-type": "dropdown-wrapper", children: /* @__PURE__ */ z(
    F.Root,
    {
      open: m,
      defaultOpen: I,
      onOpenChange: p || O ? void 0 : f,
      children: [
        /* @__PURE__ */ a(
          F.Trigger,
          {
            "data-testid": `${s}-trigger`,
            onClick: Q,
            disabled: p,
            role: "button",
            asChild: A,
            style: A ? {} : { width: "100%" },
            tabIndex: A ? 0 : -1,
            "aria-label": "Toggle dropdown menu",
            ref: D,
            children: u
          }
        ),
        h
      ]
    }
  ) });
};
export {
  _e as DROPDOWN_DEFAULT_TESTID,
  ie as Dropdown
};
//# sourceMappingURL=index.es72.js.map
